import React from 'react';
import { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  description?: string;
  children?: React.ReactNode;
  className?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon: Icon,
  title,
  description,
  children,
  className,
}) => {
  return (
    <div className={cn(
      "flex flex-col items-center justify-center text-center py-10 px-6",
      className
    )}>
      {Icon && (
        <div className="rounded-full bg-muted/30 p-3 mb-4">
          <Icon className="h-6 w-6 text-muted-foreground" />
        </div>
      )}
      
      <h3 className="text-lg font-medium mb-1">{title}</h3>
      
      {description && (
        <p className="text-sm text-muted-foreground max-w-md">
          {description}
        </p>
      )}
      
      {children && <div className="mt-4">{children}</div>}
    </div>
  );
}; 